import styled from "styled-components";

export const StyledFilterButtonLabel = styled.div`
    display: flex;
    min-width: 0;
    flex: 1 1 auto;
    white-space: nowrap;
`;
